module.exports = __webpack_public_path__ + "media/icons/twitter@3x-7dc4b1fc.svg";